import { inject, Injectable } from "@angular/core";
import { HttpService } from "../../core/services";
import type { ChatAttachmentUploadRequest, ChatDeleteRequest, ChatEditRequest, ChatGetRequestPayload, ChatReactionRequest } from "./chat.models";

@Injectable({
  providedIn: 'root'
})

export class ChatApi {
    private readonly httpService = inject(HttpService);

    getChatMessages(payload: ChatGetRequestPayload) {
        const queryParams = new URLSearchParams();

        if (payload.limit) {
            queryParams.set('limit', String(payload.limit));
        }

        if (payload.beforeMessageId) {
            queryParams.set('before_message_id', payload.beforeMessageId);
        }

        const suffix = queryParams.size ? `?${queryParams.toString()}` : '';
        return this.httpService.get(`chat/${payload.channelId}${suffix}`, true);
    }

    deleteChatMessage(payload: ChatDeleteRequest) {
        return this.httpService.delete(`chat/${payload.channel_id}/messages/${payload.message_id}`, true);
    }

    editChatMessage(payload: ChatEditRequest) {
        return this.httpService.put(`chat/${payload.channel_id}/messages/${payload.message_id}`, {
            message: payload.message,
        }, true);
    }

    toggleChatReaction(payload: ChatReactionRequest) {
        return this.httpService.put(`chat/${payload.channel_id}/messages/${payload.message_id}/reactions`, {
            emoji: payload.emoji,
        }, true);
    }

    uploadAttachment(payload: ChatAttachmentUploadRequest) {
        const formData = new FormData();
        formData.append('file', payload.file);
        if (payload.message?.trim()) {
            formData.append('message', payload.message.trim());
        }
        if (payload.attributes && Object.keys(payload.attributes).length > 0) {
            formData.append('attributes', JSON.stringify(payload.attributes));
        }
        return this.httpService.postForm(`chat/${payload.channel_id}/attachments`, formData, true);
    }
}
